var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisDeplacer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 0.5,
    width: 3.9,
    height: 2.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: 0.5,
    width: 3.4,
    height: 2.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,4.5V2.6h2.1V0.5H4.2C3,0.5,2.1,1.4,2.1,2.6v1.9H4.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 10.5,
    width: 2.1,
    height: 2.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 6.1,
    width: 2.1,
    height: 2.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.1,
    y: 14.8,
    width: 2.1,
    height: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,4.7H8.3c-1.2,0-2.1,0.9-2.1,2.1v14.6c0,1.2,0.9,2.1,2.1,2.1h11.5c1.2,0,2.1-0.9,2.1-2.1V6.8C21.9,5.6,21,4.7,19.8,4.7 z M19.8,21.4H8.3V6.8h11.5V21.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisDeplacer);
export default __webpack_public_path__ + "static/media/action_gris_deplacer.50560603.svg";
export { ForwardRef as ReactComponent };